import React from 'react';
import { FadeIn } from './FadeIn';
import { GiftIcon, CheckCircle2Icon, PaletteIcon, BookCopyIcon, PackageIcon } from 'lucide-react';
export function TriadAndBonuses() {
  const pilares = [{
    icon: <BookCopyIcon className="w-8 h-8 text-white" data-id="element-228" />,
    num: '01',
    title: 'Técnica Real',
    desc: 'Materiales, estructuras, encuadernación. El "por qué" detrás de cada paso. Para que nunca más tengas que improvisar.'
  }, {
    icon: <PaletteIcon className="w-8 h-8 text-white" data-id="element-229" />,
    num: '02',
    title: 'Creatividad con Sistema',
    desc: 'Art journal, color, capas y decoración con criterio. Para que cada proyecto tenga identidad y no se vea igual al de todas.'
  }, {
    icon: <PackageIcon className="w-8 h-8 text-white" data-id="element-230" />,
    num: '03',
    title: 'Precio y Presentación',
    desc: 'Acabados premium, fotografía, packaging y precio justo. Para que tu trabajo finalmente valga lo que realmente vale.'
  }];
  const bonuses = [{
    title: 'Guía de Proveedores Argentina y Latinoamérica',
    desc: 'Dónde comprar más barato, cuándo comprar y cómo construir tu red de proveedores mayoristas.',
    value: '$15 USD'
  }, {
    title: 'Checklist de Herramientas y Materiales Esenciales',
    desc: 'Inventario completo, planillas imprimibles y sistema de stock para nunca quedarte sin lo que necesitás.',
    value: '$12 USD'
  }, {
    title: 'Colección de Etiquetas Imprimibles Vintage',
    desc: '230 etiquetas en 8 estilos distintos. Listas para imprimir, cortar y usar en tus proyectos.',
    value: '$20 USD'
  }, {
    title: 'Paletas de Color Efectivas para Craft',
    desc: '40 paletas maestras con proporciones 60-30-10 y materiales equivalentes para Latinoamérica.',
    value: '$12 USD'
  }, {
    title: 'Masterclass PDF: Tu Craft en Redes Sociales',
    desc: 'Sistema de fotografía, plan de contenido de 30 días y estrategia de ventas para Instagram y TikTok.',
    value: '$25 USD'
  }];
  return <section className="py-16 sm:py-24 px-5 bg-brand-cream" data-id="element-231">
      <div className="max-w-6xl mx-auto" data-id="element-232">
        {/* 3 Pilares */}
        <FadeIn className="mb-16 sm:mb-20" data-id="element-233">
          <div className="text-center mb-10 sm:mb-14" data-id="element-234">
            <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-235">
              Los 3 pilares
            </span>
            <h3 className="text-3xl sm:text-5xl font-black text-brand-ink mt-4" data-id="element-236">
              Técnica, Creatividad
              <br data-id="element-237" />y Negocio en un solo lugar.
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6" data-id="element-238">
            {pilares.map((item, i) => <div key={i} className="bg-brand-ink p-6 sm:p-8 rounded-2xl transform hover:-translate-y-2 transition-transform relative overflow-hidden" data-id="element-239">
                <div className="absolute top-4 right-4 text-white/5 font-black text-7xl" data-id="element-240">
                  {item.num}
                </div>
                <div className="bg-brand-gold/20 w-14 h-14 rounded-xl flex items-center justify-center mb-6" data-id="element-241">
                  {item.icon}
                </div>
                <h4 className="text-2xl font-black text-white mb-3" data-id="element-242">
                  {item.title}
                </h4>
                <p className="text-white/60 leading-relaxed text-sm" data-id="element-243">
                  {item.desc}
                </p>
              </div>)}
          </div>
        </FadeIn>

        {/* Bonuses */}
        <FadeIn delay={0.2} data-id="element-244">
          <div className="bg-brand-paper border border-brand-line rounded-3xl p-6 sm:p-12" data-id="element-245">
            <div className="text-center mb-10 sm:mb-12" data-id="element-246">
              <div className="inline-flex items-center gap-2 text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-247">
                <GiftIcon className="w-4 h-4" data-id="element-248" />
                Bonos incluidos sin costo extra
              </div>
              <h3 className="text-3xl sm:text-4xl font-black text-brand-ink mt-4 mb-4" data-id="element-249">
                5 Bonos que valen más
                <br data-id="element-250" />
                que el bundle solo.
              </h3>
              <p className="text-brand-muted text-lg max-w-xl mx-auto" data-id="element-251">
                Valor total de los bonos:{' '}
                <strong className="text-brand-ink" data-id="element-252">$84 USD</strong>. Incluidos
                completos con tu compra de $19.990.
              </p>
            </div>

            <div className="space-y-4" data-id="element-253">
              {bonuses.map((bonus, i) => <div key={i} className="flex items-start gap-4 sm:gap-5 bg-brand-cream p-4 sm:p-5 border border-brand-line rounded-xl hover:border-brand-gold/40 transition-colors" data-id="element-254">
                  <div className="bg-brand-gold/10 border border-brand-gold/20 rounded-lg w-10 h-10 flex items-center justify-center shrink-0" data-id="element-255">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-gold" data-id="element-256" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-257">
                    <div className="flex flex-col sm:flex-row items-start sm:justify-between gap-1.5 sm:gap-4" data-id="element-258">
                      <h5 className="text-brand-ink font-bold text-sm sm:text-base" data-id="element-259">
                        {bonus.title}
                      </h5>
                      <span className="text-brand-gold font-black text-xs sm:text-sm shrink-0 bg-brand-goldLight px-2 py-1 rounded-full" data-id="element-260">
                        Valor {bonus.value}
                      </span>
                    </div>
                    <p className="text-brand-muted text-sm mt-1 leading-relaxed" data-id="element-261">
                      {bonus.desc}
                    </p>
                  </div>
                </div>)}
            </div>

            {/* Total value */}
            <div className="mt-10 pt-8 border-t border-brand-line flex flex-col sm:flex-row items-center sm:justify-between gap-6 text-center sm:text-left" data-id="element-262">
              <div data-id="element-263">
                <p className="text-brand-muted text-sm" data-id="element-264">
                  Valor total del bundle completo
                </p>
                <p className="text-brand-ink font-black text-3xl sm:text-4xl" data-id="element-265">
                  $256+ USD
                </p>
              </div>
              <div className="text-center" data-id="element-266">
                <p className="text-brand-muted text-sm mb-1" data-id="element-267">
                  Tu inversión hoy
                </p>
                <p className="text-brand-gold font-black text-4xl sm:text-5xl" data-id="element-268">
                  $19.990
                </p>
              </div>
              <a href="#oferta" className="w-full sm:w-auto text-center bg-brand-gold hover:bg-brand-goldHover text-white font-bold px-8 py-4 rounded-xl transition-all hover:-translate-y-0.5 shadow-[0_8px_20px_rgba(184,137,79,0.3)]" data-id="element-269">
                Quiero este precio →
              </a>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}